import {FontAwesomeIcon as Icon} from "@fortawesome/react-fontawesome"
import {Auction} from "domain-models"
import {useApp} from "hooks/StateHooks"
import moment from 'moment'
import React from 'react'
import {dateTime, relative, relativeNonUtc} from "../filters"
import Trans from './Trans'

type CountdownProps = {
  timeTillDate: string
  timeFormat?: string
  auction: Auction
  hotBid?: boolean
  small?: boolean
  onlyLargest?: boolean
}

type CountdownState = {
  days: number
  hours: number
  minutes: number
  seconds: number
  endsIn: string
  hotBid: boolean
}

class Countdown extends React.Component<CountdownProps, CountdownState> {
  private app = useApp()

  constructor(props: CountdownProps) {
    super(props)

    this.state = {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      endsIn: '',
      hotBid: false,
    }
  }

  componentDidMount() {
    this.setCountdown()
  }

  componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval)
    }
  }

  render() {
    const {days, hours, minutes, seconds, endsIn, hotBid} = this.state

    return (
      <div className={'flex flex-row justify-start items-center text-gray-600 font-semibold text-lg h-10 my-2 ml-2 ' + (hotBid && this.props.hotBid ? ' text-red-100 bg-red-800 ' : '') + (this.props.small ? ' p-0' : ' px-2')}>

        {
          hotBid && this.props.hotBid && status !== 'ended' && this.props.auction.status !== 'ended' && this.props.auction.status !== 'not-started-yet' ?
            <div className={"flex items-center justify-center mx-4"}>
              <Icon icon="fire" className="text-red-100 fa-beat"/>
            </div>
            : null
        }

        {
          !this.state.hotBid && (days > 0 || hours > 0 || minutes > 0 || seconds > 0) && this.props.auction.status !== 'ended' && this.props.auction.status !== 'not-started-yet' ?
            <div className={"w-0 flex items-center justify-center mr-4"}>
              <Icon icon="circle" className="text-green-600"/>
            </div>
            : null
        }

        {
          this.props.auction.status === 'ended' || this.props.auction.status === 'not-started-yet' ?
            <div className={"w-0 flex items-center justify-center mr-4"}>
              <Icon icon="circle" className="text-red-600"/>
            </div>
            : null
        }

        {this.props.auction.status === 'not-started-yet' && this.props.auction.round?.StartsOn ?
          <div className={'flex flex-row flex-wrap items-center justify-end whitespace-no-wrap'}>
            <span><Trans>Startet</Trans></span>

            {
              this.props.small ? null :
              <span className={'ml-1'}>{relativeNonUtc(this.props.auction.round?.StartsOn)}</span>
            }

            <span className={'ml-1'}> am {dateTime(this.props.auction.round?.StartsOn)}</span>
          </div>
          :
          <div className={'flex flex-row flex-wrap items-center justify-end whitespace-no-wrap'}>
            {
              days > 0 || hours > 0 || minutes >= 5 ?
              <span className='mr-2'> {endsIn} </span>
              :
              seconds > 0 || minutes > 0 || hours > 0 ?
                <span className={'mr-2' + (hotBid && this.props.hotBid ? ' text-red-100' : '')}> {endsIn}</span>
                :
                <span className='mr-2'> <Trans>Auktion beendet</Trans> - {relativeNonUtc(this.props.timeTillDate || this.props.auction.round?.EndsOn)}</span>
            }
          </div>
        }
      </div>
    )
  }

  private getEndsIn(days: number, hours: number, minutes: number, seconds: number) {
    let endsIn = ''

    if (days) {
      endsIn += days + (days > 1 ? ' Tagen ' : ' Tag ')
    }

    if (days <= 4 && hours && (!this.props.onlyLargest || !days)) {
      endsIn += hours + (hours > 1 ? ' Stunden ' : ' Stunde ')
    }

    if (!days && minutes && (!this.props.onlyLargest || (!hours && !days))) {
      endsIn += minutes + (minutes > 1 ? ' Minuten ' : ' Minute ')
    }

    if (!days && !hours && (!this.props.onlyLargest || (!hours && !days && !minutes))) {
      endsIn += seconds + (seconds > 1 ? ' Sekunden ' : ' Sekunde ')
    }

    return endsIn
  }

  private setCountdown = () => {
    const settings = this.app.settings
    const {timeTillDate, timeFormat} = this.props
    const now = moment()
    const countdown = moment(timeTillDate, timeFormat)

    const days = countdown.diff(now, 'days')
    const hours = countdown.subtract(days, 'days').diff(now, 'hours')
    const minutes = countdown.subtract(hours, 'hours').diff(now, 'minutes')
    const seconds = countdown.subtract(minutes, 'minutes').diff(now, 'seconds')

    let endsIn = this.getEndsIn(days, hours, minutes, seconds)

    let hotBid = false
    if (settings.hotBid &&
      this.props.auction.round?.Type === 1 &&
      moment(timeTillDate, timeFormat).diff(moment(), 'seconds') <= (settings.hotBid.starts * 60) &&
      this.props.auction.status !== 'ended'
    ) {
      hotBid = true
    }

    this.setState({days, hours, minutes, seconds, endsIn, hotBid})
  }

  private interval = setInterval(this.setCountdown, 1000)
}

export default Countdown

